const productData = [
  {
    id: 1,
    slug: "bronze-cut-spaghetti",
    name: "Bronze-Cut Spaghetti",
    category: "Pasta & Grains",
    price: 9.5,
    images: ["/img/product-01.jpg"],
    description: "Slow-dried durum wheat spaghetti with a rough, sauce-loving surface.",
    longDescription:
      "This everyday spaghetti is extruded through bronze dies and dried gently for a firm, satisfying bite. Its porous texture holds silky tomato sauces, garlic oil, and simple pantry ragù beautifully.",
    attributes: {
      origin: "Campania, Italy",
      ingredients: "Durum wheat semolina, water",
      dietary: "Vegan",
      shape: "Spaghetti",
      storage: "Store in a cool, dry place",
    },
    tags: ["pasta", "durum-wheat", "bronze-cut", "vegan"],
    rating: 4.9,
    reviews: 128,
    stock: 64,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "500 g",
  },
  {
    id: 2,
    slug: "ridged-paccheri",
    name: "Ridged Paccheri",
    category: "Pasta & Grains",
    price: 11,
    images: ["/img/product-02.jpg"],
    description: "Generous ridged pasta tubes made for baked dishes and hearty sauces.",
    longDescription:
      "Wide, sturdy paccheri offer a dramatic shape without losing their tender chew. Pair them with slow-cooked vegetables, seafood, or a spoonful of ricotta before baking.",
    attributes: {
      origin: "Campania, Italy",
      ingredients: "Durum wheat semolina, water",
      dietary: "Vegan",
      shape: "Paccheri rigati",
      storage: "Store in a cool, dry place",
    },
    tags: ["pasta", "paccheri", "oven-baked", "vegan"],
    rating: 4.8,
    reviews: 84,
    stock: 42,
    featured: false,
    bestseller: true,
    newArrival: false,
    unit: "500 g",
  },
  {
    id: 3,
    slug: "golden-egg-pappardelle",
    name: "Golden Egg Pappardelle",
    category: "Pasta & Grains",
    price: 13.5,
    compareAtPrice: 15,
    images: ["/img/product-03.jpg"],
    description: "Broad, ribbon-like egg pasta with a delicate texture and rich color.",
    longDescription:
      "Rolled into wide ribbons, this pappardelle cooks quickly and keeps an elegant, supple bite. It is especially lovely with mushrooms, braised vegetables, or a butter-and-herb sauce.",
    attributes: {
      origin: "Emilia-Romagna, Italy",
      ingredients: "Durum wheat semolina, eggs",
      dietary: "Vegetarian",
      shape: "Pappardelle",
      storage: "Store in a cool, dry place",
    },
    tags: ["egg-pasta", "pappardelle", "ribbon-pasta", "vegetarian"],
    rating: 4.7,
    reviews: 67,
    stock: 31,
    featured: true,
    bestseller: false,
    newArrival: false,
    unit: "250 g",
  },
  {
    id: 4,
    slug: "puglian-orecchiette",
    name: "Puglian Orecchiette",
    category: "Pasta & Grains",
    price: 10.5,
    images: ["/img/product-04.jpg"],
    description: "Little ear-shaped pasta with a cupped center for greens and crumbled cheese.",
    longDescription:
      "The gently domed shape catches flavorful bits while the thicker rim stays pleasantly al dente. Toss with broccoli rabe, toasted breadcrumbs, or a bright tomato sauce.",
    attributes: {
      origin: "Puglia, Italy",
      ingredients: "Durum wheat semolina, water",
      dietary: "Vegan",
      shape: "Orecchiette",
      storage: "Store in a cool, dry place",
    },
    tags: ["pasta", "orecchiette", "puglia", "vegan"],
    rating: 4.8,
    reviews: 92,
    stock: 55,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "500 g",
  },
  {
    id: 5,
    slug: "carnaroli-risotto-rice",
    name: "Carnaroli Risotto Rice",
    category: "Pasta & Grains",
    price: 14,
    images: ["/img/product-05.jpg"],
    description: "Plump Italian rice grains prized for creamy risotto with a distinct center.",
    longDescription:
      "Carnaroli releases starch gradually while remaining resilient through stirring and ladling. The result is a naturally creamy risotto with well-defined grains and an elegant finish.",
    attributes: {
      origin: "Piedmont, Italy",
      ingredients: "Carnaroli rice",
      dietary: "Vegan, naturally gluten-free",
      variety: "Carnaroli",
      storage: "Reseal and store in a cool, dry place",
    },
    tags: ["rice", "risotto", "gluten-free", "vegan"],
    rating: 4.9,
    reviews: 111,
    stock: 47,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "1 kg",
  },
  {
    id: 6,
    slug: "stone-ground-polenta",
    name: "Stone-Ground Polenta",
    category: "Pasta & Grains",
    price: 8.75,
    images: ["/img/product-06.jpg"],
    description: "Coarsely milled yellow cornmeal for slow-cooked, velvety polenta.",
    longDescription:
      "A rustic grind gives this polenta a warm corn aroma and softly textured finish. Serve it creamy beneath roasted vegetables or chill, slice, and crisp it in a pan.",
    attributes: {
      origin: "Veneto, Italy",
      ingredients: "Stone-ground yellow corn",
      dietary: "Vegan, naturally gluten-free",
      grind: "Coarse",
      storage: "Store sealed in a cool, dry place",
    },
    tags: ["polenta", "cornmeal", "gluten-free", "vegan"],
    rating: 4.6,
    reviews: 49,
    stock: 38,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "500 g",
  },
  {
    id: 7,
    slug: "sun-ripened-whole-tomatoes",
    name: "Sun-Ripened Whole Tomatoes",
    category: "Tomatoes & Sauces",
    price: 8,
    images: ["/img/product-07.jpg"],
    description: "Tender peeled tomatoes packed in their own bright, lightly salted juice.",
    longDescription:
      "Harvested at full ripeness, these whole tomatoes balance gentle sweetness with lively acidity. Crush them by hand for pizza, simmer into a quick sauce, or spoon them into braises.",
    attributes: {
      origin: "Southern Italy",
      ingredients: "Peeled tomatoes, tomato juice, sea salt",
      dietary: "Vegan, naturally gluten-free",
      packaging: "BPA-free lined tin",
      storage: "Refrigerate after opening and use within 3 days",
    },
    tags: ["tomatoes", "pizza", "sauce-starter", "vegan"],
    rating: 4.9,
    reviews: 176,
    stock: 89,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "800 g",
  },
  {
    id: 8,
    slug: "slow-roasted-tomato-passata",
    name: "Slow-Roasted Tomato Passata",
    category: "Tomatoes & Sauces",
    price: 9.75,
    images: ["/img/product-08.jpg"],
    description: "Silky strained tomatoes with a mellow, oven-roasted sweetness.",
    longDescription:
      "This smooth passata begins with ripe tomatoes roasted just long enough to deepen their flavor. It makes an easy base for pasta sauce, soup, shakshuka, and weeknight braises.",
    attributes: {
      origin: "Basilicata, Italy",
      ingredients: "Tomatoes, sea salt",
      dietary: "Vegan, naturally gluten-free",
      texture: "Smooth",
      storage: "Refrigerate after opening and use within 5 days",
    },
    tags: ["passata", "tomatoes", "weeknight", "vegan"],
    rating: 4.7,
    reviews: 73,
    stock: 62,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "680 g",
  },
  {
    id: 9,
    slug: "basil-pomodoro-sauce",
    name: "Basil Pomodoro Sauce",
    category: "Tomatoes & Sauces",
    price: 12.5,
    images: ["/img/product-09.jpg"],
    description: "A clean, aromatic tomato sauce finished with basil and extra virgin olive oil.",
    longDescription:
      "Ripe tomatoes, onion, and basil simmer into a balanced sauce with a homemade texture. Warm it gently for pasta, layer it into lasagna, or use it as a simple pizza base.",
    attributes: {
      origin: "Tuscany, Italy",
      ingredients: "Tomatoes, onion, extra virgin olive oil, basil, sea salt",
      dietary: "Vegan, naturally gluten-free",
      texture: "Rustic smooth",
      storage: "Refrigerate after opening and use within 4 days",
    },
    tags: ["tomato-sauce", "basil", "ready-to-serve", "vegan"],
    rating: 4.8,
    reviews: 104,
    stock: 51,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "500 g",
  },
  {
    id: 10,
    slug: "sweet-pepper-sugo",
    name: "Sweet Pepper Sugo",
    category: "Tomatoes & Sauces",
    price: 13,
    compareAtPrice: 15.5,
    images: ["/img/product-10.jpg"],
    description: "A velvety tomato and sweet pepper sauce with a whisper of chile warmth.",
    longDescription:
      "Red peppers lend this sugo a rounded sweetness while a small measure of chile keeps the finish lively. Spoon over pasta, grilled bread, roasted fish, or creamy beans.",
    attributes: {
      origin: "Calabria, Italy",
      ingredients: "Tomatoes, red peppers, onion, olive oil, chile, sea salt",
      dietary: "Vegan, naturally gluten-free",
      heatLevel: "Mild",
      storage: "Refrigerate after opening and use within 4 days",
    },
    tags: ["pepper-sauce", "calabrian-inspired", "mild-heat", "vegan"],
    rating: 4.6,
    reviews: 58,
    stock: 29,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "350 g",
  },
  {
    id: 11,
    slug: "nocellara-extra-virgin-olive-oil",
    name: "Nocellara Extra Virgin Olive Oil",
    category: "Olive Oil & Vinegar",
    price: 28,
    images: ["/img/product-11.jpg"],
    description: "A vivid green olive oil with grassy aromas and a clean peppery finish.",
    longDescription:
      "Pressed from Nocellara olives, this expressive oil tastes of cut grass, green almond, and fresh herbs. Save it for finishing soups, salads, vegetables, and warm bread.",
    attributes: {
      origin: "Sicily, Italy",
      ingredients: "100% extra virgin olive oil",
      dietary: "Vegan, naturally gluten-free",
      oliveVariety: "Nocellara",
      harvest: "Early harvest",
    },
    tags: ["olive-oil", "sicily", "early-harvest", "finishing-oil"],
    rating: 4.9,
    reviews: 143,
    stock: 44,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "500 ml",
  },
  {
    id: 12,
    slug: "ligurian-lemon-olive-oil",
    name: "Ligurian Lemon Olive Oil",
    category: "Olive Oil & Vinegar",
    price: 24,
    images: ["/img/product-12.jpg"],
    description: "Extra virgin olive oil pressed with lemon for a fragrant citrus lift.",
    longDescription:
      "Whole lemons meet olives during pressing, creating an integrated aroma rather than a flavored afterthought. Drizzle it over seafood, shaved fennel, grilled zucchini, or olive-oil cake.",
    attributes: {
      origin: "Liguria, Italy",
      ingredients: "Extra virgin olive oil, lemons",
      dietary: "Vegan, naturally gluten-free",
      flavor: "Fresh lemon, mild pepper",
      storage: "Keep away from heat and direct light",
    },
    tags: ["olive-oil", "lemon", "liguria", "finishing-oil"],
    rating: 4.8,
    reviews: 96,
    stock: 36,
    featured: true,
    bestseller: false,
    newArrival: true,
    unit: "250 ml",
  },
  {
    id: 13,
    slug: "sangiovese-wine-vinegar",
    name: "Aged Sangiovese Wine Vinegar",
    category: "Olive Oil & Vinegar",
    price: 18.5,
    images: ["/img/product-13.jpg"],
    description: "Rounded red wine vinegar with berry notes and a softly oaked finish.",
    longDescription:
      "Made from Sangiovese wine and rested in wood, this vinegar brings brightness without sharpness. Whisk it into vinaigrette, splash it into lentils, or use it to balance a pan sauce.",
    attributes: {
      origin: "Tuscany, Italy",
      ingredients: "Sangiovese wine vinegar",
      dietary: "Vegan, naturally gluten-free",
      acidity: "6%",
      aging: "Wood rested",
    },
    tags: ["vinegar", "sangiovese", "tuscany", "vinaigrette"],
    rating: 4.7,
    reviews: 51,
    stock: 33,
    featured: false,
    bestseller: false,
    newArrival: false,
    unit: "250 ml",
  },
  {
    id: 14,
    slug: "fig-balsamic-condiment",
    name: "Fig Balsamic Condiment",
    category: "Olive Oil & Vinegar",
    price: 21,
    compareAtPrice: 24,
    images: ["/img/product-14.jpg"],
    description: "A dark, pourable balsamic condiment layered with ripe fig sweetness.",
    longDescription:
      "Cooked grape must and wine vinegar are blended with figs for a glossy condiment that remains pleasantly balanced. Pair it with aged cheese, roasted squash, strawberries, or vanilla gelato.",
    attributes: {
      origin: "Emilia-Romagna, Italy",
      ingredients: "Cooked grape must, wine vinegar, figs",
      dietary: "Vegan, naturally gluten-free",
      texture: "Pourable glaze",
      storage: "Store at room temperature away from direct light",
    },
    tags: ["balsamic", "fig", "cheese-board", "giftable"],
    rating: 4.8,
    reviews: 78,
    stock: 25,
    featured: true,
    bestseller: false,
    newArrival: false,
    unit: "250 ml",
  },
  {
    id: 15,
    slug: "citrus-herb-sea-salt",
    name: "Citrus & Herb Sea Salt",
    category: "Herbs & Antipasti",
    price: 12,
    images: ["/img/product-15.jpg"],
    description: "Flaky sea salt brightened with lemon peel, rosemary, and thyme.",
    longDescription:
      "A pinch adds savory sparkle and fresh citrus aroma without overpowering the dish. Finish roast chicken, potatoes, focaccia, grilled vegetables, or a bowl of white beans.",
    attributes: {
      origin: "Sicily, Italy",
      ingredients: "Sea salt, lemon peel, rosemary, thyme",
      dietary: "Vegan, naturally gluten-free",
      texture: "Coarse flakes",
      storage: "Keep tightly sealed and dry",
    },
    tags: ["sea-salt", "citrus", "herbs", "finishing"],
    rating: 4.7,
    reviews: 63,
    stock: 58,
    featured: false,
    bestseller: true,
    newArrival: false,
    unit: "180 g",
  },
  {
    id: 16,
    slug: "wild-fennel-pollen",
    name: "Wild Fennel Pollen",
    category: "Herbs & Antipasti",
    price: 19.5,
    images: ["/img/product-16.jpg"],
    description: "Intensely aromatic fennel pollen with floral, anise-like warmth.",
    longDescription:
      "Only a small pinch is needed to transform roasted vegetables, pork, fish, or fresh cheese. Its delicate texture melts into a dish while leaving a lingering, honeyed fennel aroma.",
    attributes: {
      origin: "Umbria, Italy",
      ingredients: "Wild fennel pollen",
      dietary: "Vegan, naturally gluten-free",
      aroma: "Floral fennel and anise",
      storage: "Keep tightly sealed away from light",
    },
    tags: ["fennel", "pollen", "seasoning", "umbrian"],
    rating: 4.9,
    reviews: 87,
    stock: 21,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "25 g",
  },
  {
    id: 17,
    slug: "porcini-herb-seasoning",
    name: "Porcini & Herb Seasoning",
    category: "Herbs & Antipasti",
    price: 14.5,
    images: ["/img/product-17.jpg"],
    description: "A savory blend of porcini, parsley, garlic, and cracked black pepper.",
    longDescription:
      "Dried porcini bring deep woodland character to this versatile pantry blend. Stir it into risotto, fold it through breadcrumbs, or season potatoes and creamy sauces.",
    attributes: {
      origin: "Northern Italy",
      ingredients: "Dried porcini, parsley, garlic, black pepper, sea salt",
      dietary: "Vegan, naturally gluten-free",
      flavor: "Earthy and savory",
      storage: "Keep tightly sealed and dry",
    },
    tags: ["porcini", "seasoning", "risotto", "umami"],
    rating: 4.6,
    reviews: 46,
    stock: 39,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "80 g",
  },
  {
    id: 18,
    slug: "green-olive-antipasto",
    name: "Green Olive Antipasto",
    category: "Herbs & Antipasti",
    price: 15,
    images: ["/img/product-18.jpg"],
    description: "Crisp green olives marinated with citrus peel, oregano, and mild chile.",
    longDescription:
      "These meaty olives arrive ready for aperitivo, with a lively marinade that is fragrant rather than fiery. Serve straight from the jar or chop them into salads, focaccia, and pasta.",
    attributes: {
      origin: "Sicily, Italy",
      ingredients: "Green olives, brine, orange peel, oregano, chile",
      dietary: "Vegan, naturally gluten-free",
      preparation: "Pitted",
      storage: "Refrigerate after opening and keep covered in brine",
    },
    tags: ["olives", "antipasti", "aperitivo", "vegan"],
    rating: 4.8,
    reviews: 119,
    stock: 48,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "290 g",
  },
  {
    id: 19,
    slug: "hazelnut-cocoa-crema",
    name: "Hazelnut Cocoa Crema",
    category: "Sweets & Preserves",
    price: 17.5,
    images: ["/img/product-19.jpg"],
    description: "A silky roasted hazelnut spread with deep cocoa and restrained sweetness.",
    longDescription:
      "Roasted hazelnuts lead the flavor, supported by dark cocoa and a smooth spoonable texture. Spread it on toast, swirl it into yogurt, or warm a spoonful over gelato.",
    attributes: {
      origin: "Piedmont, Italy",
      ingredients: "Hazelnuts, cane sugar, cocoa, sunflower oil, sea salt",
      dietary: "Vegan, naturally gluten-free",
      texture: "Smooth",
      storage: "Store at room temperature and stir if separated",
    },
    tags: ["hazelnut", "cocoa", "spread", "piedmont"],
    rating: 4.9,
    reviews: 152,
    stock: 35,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "250 g",
  },
  {
    id: 20,
    slug: "almond-cantucci",
    name: "Tuscan Almond Cantucci",
    category: "Sweets & Preserves",
    price: 13,
    images: ["/img/product-20.jpg"],
    description: "Twice-baked almond biscuits with a crisp snap and gentle citrus aroma.",
    longDescription:
      "Whole almonds bring richness and crunch to these classically firm biscuits. Dip them into coffee, dessert wine, or tea, or crumble them over fruit and mascarpone.",
    attributes: {
      origin: "Tuscany, Italy",
      ingredients: "Wheat flour, almonds, sugar, eggs, orange zest, sea salt",
      dietary: "Vegetarian",
      texture: "Crisp",
      storage: "Reseal after opening",
    },
    tags: ["biscuits", "almond", "cantucci", "coffee-pairing"],
    rating: 4.7,
    reviews: 81,
    stock: 56,
    featured: false,
    bestseller: true,
    newArrival: false,
    unit: "250 g",
  },
  {
    id: 21,
    slug: "pistachio-torroncini",
    name: "Soft Pistachio Torroncini",
    category: "Sweets & Preserves",
    price: 18,
    compareAtPrice: 20,
    images: ["/img/product-21.jpg"],
    description: "Individually wrapped soft nougat bites studded with roasted pistachios.",
    longDescription:
      "Honeyed nougat stays tender while generous pistachios add color and savory crunch. The small wrapped pieces make an easy after-dinner treat or a thoughtful addition to a gift box.",
    attributes: {
      origin: "Sicily, Italy",
      ingredients: "Honey, pistachios, sugar, egg white, wafer",
      dietary: "Vegetarian",
      texture: "Soft nougat",
      storage: "Store in a cool, dry place",
    },
    tags: ["nougat", "pistachio", "torroncini", "giftable"],
    rating: 4.8,
    reviews: 69,
    stock: 27,
    featured: true,
    bestseller: false,
    newArrival: true,
    unit: "180 g",
  },
  {
    id: 22,
    slug: "blood-orange-marmalade",
    name: "Blood Orange Marmalade",
    category: "Sweets & Preserves",
    price: 14.5,
    images: ["/img/product-22.jpg"],
    description: "Ruby-hued citrus preserve balancing bright fruit, peel, and gentle bitterness.",
    longDescription:
      "Whole blood oranges are cooked in small batches to preserve their vivid aroma and pleasantly bitter edge. Spoon onto toast, pair with fresh cheese, or brush over an olive-oil cake.",
    attributes: {
      origin: "Sicily, Italy",
      ingredients: "Blood oranges, cane sugar, lemon juice",
      dietary: "Vegan, naturally gluten-free",
      fruitContent: "High fruit",
      storage: "Refrigerate after opening",
    },
    tags: ["marmalade", "blood-orange", "sicily", "breakfast"],
    rating: 4.7,
    reviews: 74,
    stock: 40,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "280 g",
  },
  {
    id: 23,
    slug: "morning-bar-espresso-blend",
    name: "Morning Bar Espresso Blend",
    category: "Coffee & Tea",
    price: 16,
    images: ["/img/product-23.jpg"],
    description: "A round, medium-dark coffee blend with cocoa, toasted nut, and caramel notes.",
    longDescription:
      "Blended for a syrupy espresso and a balanced cup from a moka pot, these beans finish sweet and clean. The roast stands up to milk while remaining smooth enough to drink on its own.",
    attributes: {
      origin: "Roasted in Italy",
      ingredients: "Whole roasted coffee beans",
      dietary: "Vegan, naturally gluten-free",
      roast: "Medium-dark",
      format: "Whole bean",
    },
    tags: ["coffee", "espresso", "whole-bean", "moka-pot"],
    rating: 4.8,
    reviews: 132,
    stock: 61,
    featured: true,
    bestseller: true,
    newArrival: false,
    unit: "500 g",
  },
  {
    id: 24,
    slug: "chamomile-lemon-verbena-tisane",
    name: "Chamomile & Lemon Verbena Tisane",
    category: "Coffee & Tea",
    price: 15,
    images: ["/img/product-24.jpg"],
    description: "A caffeine-free floral infusion with lemon verbena and a soft honeyed aroma.",
    longDescription:
      "Whole chamomile flowers meet fragrant lemon verbena for a calm, clear cup after dinner. Steep it gently and enjoy warm, or chill it with citrus for a refreshing afternoon drink.",
    attributes: {
      origin: "Central Italy",
      ingredients: "Chamomile flowers, lemon verbena, lemon balm",
      dietary: "Vegan, naturally gluten-free",
      caffeine: "Caffeine-free",
      format: "Loose leaf",
    },
    tags: ["tea", "tisane", "chamomile", "caffeine-free"],
    rating: 4.6,
    reviews: 42,
    stock: 34,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "60 g",
  },
  {
    id: 25,
    slug: "rosemary-pine-nut-crackers",
    name: "Rosemary & Pine Nut Crackers",
    category: "Herbs & Antipasti",
    price: 58,
    images: ["/img/product-25.jpg"],
    description: "Crisp, savory crackers baked with rosemary, pine nuts, and sea salt.",
    longDescription:
      "Thin and gently blistered, these pantry crackers balance fragrant rosemary with buttery pine nuts. Serve with olives, soft cheese, or a spoonful of vegetable antipasto.",
    attributes: {
      origin: "Prepared for guyspruce",
      ingredients: "Wheat flour, olive oil, pine nuts, rosemary, sea salt",
      dietary: "Vegetarian",
      texture: "Thin and crisp",
      storage: "Reseal and store in a cool, dry place",
    },
    tags: ["crackers", "rosemary", "pine-nut", "aperitivo"],
    rating: 4.7,
    reviews: 36,
    stock: 45,
    featured: false,
    bestseller: false,
    newArrival: true,
    unit: "240 g",
  },
];

const compliantPrices = [52, 58, 66, 49, 72, 47, 55, 62, 69, 75, 128, 115, 88, 96, 59, 108, 79, 82, 94, 64, 118, 76, 86, 68, 58];

const compliantProductData = productData.map((product, index) => ({
  ...product,
  price: compliantPrices[index],
  ...(product.compareAtPrice
    ? { compareAtPrice: Math.min(180, compliantPrices[index] + 12) }
    : {}),
}));

export default compliantProductData;
